"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalCustomOverlay = require("./ModalCustomOverlay");
Object.keys(_ModalCustomOverlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalCustomOverlay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalCustomOverlay[key];
    }
  });
});